import React from 'react';

import DeviceContainer from '@totem/components/devices/deviceDetails/DeviceContainer';
import DeviceTabs from '@totem/components/devices/deviceDetails/DeviceTabs';
import DeviceDetailHeader from '@totem/components/devices/deviceDetails/header/DeviceDetailHeader';
import EventsContainer, {
  containerConfiguration,
} from '@totem/components/services/threats/eventsContainer/EventsContainer';
import VulnerabilityReportContainer from '@totem/components/software/vulnerabilityReport/vulnerabilityReportContainer';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

type Props = {
  deviceId: string;
};

const DeviceDetailsLayout = ({ deviceId }: Props) => {
  return (
    <>
      <DeviceContainer deviceId={deviceId}>
        <InputContainer
          componentKey={'device-events'}
          componentLabel={'Devices: Events'}
          filterConfig={containerConfiguration}
          staticFilters={[
            {
              field: 'device',
              values: [deviceId],
            },
          ]}
          defaultSort={{
            field: 'eventTime',
            direction: 'descend',
          }}
        >
          <EventsContainer>
            <DeviceDetailHeader />
            <VulnerabilityReportContainer deviceId={[deviceId]}>
              <DeviceTabs />
            </VulnerabilityReportContainer>
          </EventsContainer>
        </InputContainer>
      </DeviceContainer>
    </>
  );
};

export default DeviceDetailsLayout;
